<h2 mat-dialog-title>{{ dialogData.mode }} Organization</h2>
@if (showApiMessage) {
<ctx-alert [alertLevel]="apiMessage.alertLevel">{{
  apiMessage.text
}}</ctx-alert>
}
<form
  [formGroup]="formGroup"
  (ngSubmit)="submit(formGroup.value, dialogData, dialogRef, tab)"
>
  <mat-dialog-content>
    <ctx-tab-group #tab>
      <ctx-tab label="Details" [stepControl]="detailsTab" icon="DETAILS">
        <section class="flex flex-col gap-4">
          <!--Name -->
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="name"
              matInput
              required
            />
            <mat-error>{{ getControlError(formGroup, 'name') }}</mat-error>
          </mat-form-field>
          <!-- Email -->
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input
              autocomplete="off"
              type="email"
              formControlName="email"
              matInput
              required
            />
            <mat-hint>Notification email of the organization.</mat-hint>
            <mat-error>{{ getControlError(formGroup, 'email') }}</mat-error>
          </mat-form-field>

          <!-- Allowed Users -->
          <mat-form-field class="mat-mdc-form-field--small">
            <mat-label>Allowed Users</mat-label>
            <input
              type="number"
              formControlName="allowedUsers"
              matInput
              required
            />
            <mat-error>{{
              getControlError(formGroup, 'allowedUsers')
            }}</mat-error>
            <mat-hint
              >The maximum number of Users an Organization Admin can create.
              {{ UNLIMITED_VALUE_MINUS_ONE }}</mat-hint
            >
          </mat-form-field>

          <!-- Description -->
          <mat-form-field class="mat-mdc-form-field--small">
            <mat-label>Description</mat-label>
            <textarea
              rows="1"
              formControlName="description"
              matInput
            ></textarea>
            <mat-error>{{
              getControlError(formGroup, 'description')
            }}</mat-error>
          </mat-form-field>
        </section>
      </ctx-tab>
      <ctx-tab
        label="Address"
        [stepControl]="addressTab"
        icon="ADVANCED_SETTINGS"
      >
        <section class="flex flex-col gap-4" [formGroupName]="'address'">
          <mat-form-field>
            <mat-label>Address Line1</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="addressLine1"
              matInput
            />
            <mat-error>{{
              getControlError(formGroup, 'addressLine1')
            }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Address Line2</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="addressLine2"
              matInput
            />
            <mat-error>{{
              getControlError(formGroup, 'addressLine2')
            }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>City</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="city"
              matInput
            />
            <mat-error>{{ getControlError(formGroup, 'city') }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>State</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="state"
              matInput
            />
            <mat-error>{{ getControlError(formGroup, 'state') }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="country">
              @for (country of ALL_COUNTRIES | keyvalue : originalOrder; track
              country) {
              <mat-option [value]="country.key">
                {{ country.value }}
              </mat-option>
              }
            </mat-select>
            <mat-error>{{ getControlError(formGroup, 'country') }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Postal Code</mat-label>
            <input
              autocomplete="off"
              type="text"
              formControlName="postalCode"
              matInput
            />
            <mat-error>{{
              getControlError(formGroup, 'postalCode')
            }}</mat-error>
          </mat-form-field>
        </section>
      </ctx-tab>
    </ctx-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-dialog-close
      ctx-button--secondary
      [disabled]="formStates.disabled"
    >
      Close
    </button>
    <button
      ctx-button--primary
      [disabled]="formStates.disabled"
      [loading]="formStates.submit"
      type="submit"
    >
      {{ dialogData.mode }}
    </button>
  </mat-dialog-actions>
</form>
